import React from 'react';
import { IconSuccess16, IconError16, IconInformation16, IconFixDelivery16 } from '@stitch-fix/mode-react';
import type { ModeIcon } from '../../types/definitions/vendor/graphql-schema.d';
type SupportedIcons = Extract<ModeIcon, 'SUCCESS' | 'ERROR' | 'INFORMATION' | 'FIX_DELIVERY'>;
type IconType = typeof IconSuccess16;
const iconMap: { [key in SupportedIcons]: IconType } = {
  SUCCESS: IconSuccess16,
  ERROR: IconError16,
  INFORMATION: IconInformation16,
  FIX_DELIVERY: IconFixDelivery16
};
export type BannerIconProps = {
  icon: SupportedIcons | null;
};
const toTitleCase = (word: string) => {
  return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
};
export const isValidIcon = (key: unknown): key is SupportedIcons => Object.keys(iconMap).includes(String(key));
export const BannerIcon = ({
  icon
}: BannerIconProps) => {
  if (!icon || !isValidIcon(icon)) return null;
  const Icon = iconMap[icon];
  return Icon ? <Icon purpose="decorative" aria-label={`${toTitleCase(icon)} icon`} /> : null;
};